import * as types from './types';
import { loading } from 'State/actions';
import _ from 'lodash';
import { LetterTypeEnum } from '../../helpers/LetterTypeEnum';

export const checkForBadEmails = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING, true)
    );

    try {
      const data = { LetterTypes: ['D', 'N'] };
      const responseBadEmails = await MPWWebApi.postGenericInsertUpdate(
        'Letter/GetBadEmailLetterHistory',
        data
      );

      dispatch({
        type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_BAD_EMAILS,
        payload: _.get(responseBadEmails, 'data.Data', []),
      });
    } catch (error) {
      dispatch({
        type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING,
        payload: error.response,
      });
    }

    dispatch(
      loading(types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING, false)
    );
  };
};

export const getNotificationAndDirectCertifiedLetters = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(
      loading(types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING, true)
    );

    try {
      MPWWebAPI.postGenericInsertUpdate(
        'Letter/NotificationAndDirectCertifiedLetters',
        data
      );

      switch (_.get(data, 'LetterType', LetterTypeEnum.Notification)) {
        case LetterTypeEnum.Notification:
          dispatch({
            type:
              types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_N,
            payload: [],
          });
          break;
        case LetterTypeEnum.DirectCertification:
          dispatch({
            type:
              types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_D,
            payload: [],
          });
          break;

        default:
      }
    } catch (error) {
      dispatch({
        type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOAD_ERROR,
        loadError: error.response.Errors,
      });
    }

    dispatch(
      loading(types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOADING, false)
    );
  };
};

export const clearReport = () => {
  return {
    type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_GET_LETTERS,
    payload: null,
  };
};

export const clearErrors = () => {
  return {
    type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_ERRORS,
  };
};

export const clearBadEmails = data => {
  return async (dispatch, getState, MPWWebApi) => {
    MPWWebApi.postGenericInsertUpdate(
      'Letter/WriteLetterHistoryNotifiedUserId',
      data
    );

    try {
      switch (_.get(data, 'letterType', LetterTypeEnum.Notification)) {
        case LetterTypeEnum.Notification:
          dispatch({
            type:
              types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_N,
            payload: [],
          });
          break;
        case LetterTypeEnum.DirectCertification:
          dispatch({
            type:
              types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_CLEAR_EMAILS_D,
            payload: [],
          });
          break;

        default:
      }
    } catch (error) {
      dispatch({
        type: types.NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_LOAD_ERROR,
        loadError: error.response.Errors,
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/state/letter/actions.js